<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col cols="12" class="pt-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Import/Export</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Scarica modello per Import Prodotti</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn class="mx-0" width="106" color="info" @click.native="downloadTemplate('products')">modello</v-btn>
                        </v-list-item-action>
                        <v-list-item-content></v-list-item-content>
                    </v-list-item>
                </v-list>
                
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Carica file per Import Prodotti</v-subheader>
                    <v-list-item>
                        <v-list-item-action class="ma-auto">
                            <v-btn color="info" :disabled="!fileProductToUpload" width="106" :loading="loading" @click="uploadFile('products')">upload</v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-file-input
                                class="ml-6"
                                v-model="fileProductToUpload"
                                outlined dense
                                accept=".csv"
                                small-chips
                                hide-details
                                label="File">
                            </v-file-input>                            
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Scarica modello per Import Componenti Prodotti</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn class="mx-0" width="106" color="info" @click.native="downloadTemplate('componentproduct')">modello</v-btn>
                        </v-list-item-action>
                        <v-list-item-content></v-list-item-content>
                    </v-list-item>
                </v-list>
                
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Carica file per Import Componenti Prodotti</v-subheader>
                    <v-list-item>
                        <v-list-item-action class="ma-auto">
                            <v-btn color="info" :disabled="!fileComponentToUpload" width="106" :loading="loading" @click="uploadFile('componentproduct')">upload</v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-file-input
                                class="ml-6"
                                v-model="fileComponentToUpload"
                                outlined dense
                                accept=".csv"
                                small-chips
                                hide-details
                                label="File">
                            </v-file-input>                            
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-card-actions>

                </v-card-actions>

            </v-card>
        </v-col>

        <v-col cols="12" class="pa-0 px-3 pt-1">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Altre impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Barcode</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings.enable_barcode"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Gestione Barcode</v-list-item-title>
                            <v-list-item-subtitle>Abilita la gestione dei codici a barre per i prodotti nell'applicazione
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <template v-if="settings.enable_barcode">
                        <v-subheader>Prefissi Barcode</v-subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Prefissi GS1</v-list-item-title>
                                <v-list-item-subtitle>Inserisci i codici prefissi di barcode rilasciati da enti certificatori come GS1
                                </v-list-item-subtitle>
                                <v-combobox
                                    v-model="settings.barcode_prefixes"
                                    outlined
                                    dense
                                    chips
                                    multiple
                                    small-chips
                                    label="Prefissi barcode"
                                    class="mt-2"
                                ></v-combobox>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>

                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Magazzino</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings.show_stock_in_documents"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Giacenza nei documenti</v-list-item-title>
                            <v-list-item-subtitle>Mostra la giacenza attuale dei prodotti a magazzino nella ricerca prodotto
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="pa-2 mx-3" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>              
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin.js'

    export default {
        name: 'products-options',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'products',
                settings: {
                    'enable_barcode': false,
                    'barcode_prefixes': [],
                    'show_stock_in_documents': false
                },
                fileProductToUpload: null,
                fileComponentToUpload: null,
                loading: false,
            }
        },

        computed: {
        },

        methods: {
            downloadTemplate(type) {
                let title = (type === 'products' ? 'prodotti.csv' : 'componenti prodotti.csv')
                this.$eventBusUtility.openFile(this.$store, '/' + type + '-downloadcsv/', title)
            },

            uploadFile(type) {
                this.loading = true
                var formData = new FormData();
                formData.append('file', (type === 'products' ? this.fileProductToUpload : this.fileComponentToUpload))

                this.axios.post(type + '-uploadcsv/',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json'
                        }
                    }).then(response => {
                        this.loading = false
                        this.$store.commit('setSnackbar', {timeout: 6000, text: 'Importazione Avviata', value: true, color: 'success'})
                        this.fileProductToUpload = null
                        this.fileComponentToUpload = null

                }, response => {
                    this.loading = false
                })
            },
        },
    }
</script>

<style scoped>

</style>